import {
  Box,
  CircularProgress,
  circularProgressClasses,
  linearProgressClasses,
  Typography,
} from "@mui/material";
import React from "react";

const CircularProgressWithLabel = (props) => {
  return (
    <Box sx={{ position: "relative", display: "flex" }}>
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          "& .MuiCircularProgress-circle": {
            stroke: theme.palette.background.default,
          },
        })}
        size={props?.size || 35}
        thickness={4}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        })}
        size={props?.size || 35}
        thickness={4}
        value={props?.value}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          fontWeight={props?.fontWeight || 500}
          variant={props?.variant || "subtitle"}
        >
          {props?.label || props?.value}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithLabel;
